import React from 'react';
import { CtaBlock } from '../CtaBlock';
import { HERO_IMAGE, stats } from '../../data/content';
const trust = ['Accesso immediato', 'Pagamento unico', 'Accesso a vita', 'Garanzia di 7 giorni'];
export function Hero() {
  return <header className="relative overflow-hidden bg-ink-900" data-id="element-163" data-mp="cujiy6tux9xl">
      <div className="bg-forge py-2.5 px-4 text-center" data-id="element-164" data-mp="hv7k3lbsv75j">
        <p className="font-display text-[13px] sm:text-base font-bold uppercase tracking-[0.08em] text-white" data-id="element-165" data-mp="hsl20rra9992">
          🔥 Offerta di lancio · Accesso a vita per soli 27 USD
        </p>
      </div>

      <div className="mx-auto max-w-6xl px-4 pt-8 pb-10 sm:px-6 sm:pt-12" data-id="element-166" data-mp="qt9f9k8ur5kw">
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_1fr] lg:gap-12" data-id="element-167" data-mp="vmvspemubdhr">
          <div className="text-center lg:text-left" data-id="element-168" data-mp="10k45t0t4src5">
            <p className="font-display text-sm font-bold uppercase tracking-[0.2em] text-arc-light" data-id="element-169" data-mp="15ks3u6fs28fv">
              Sistema Maestro di Saldatura™
            </p>
            <h1 className="mt-3 font-display text-[2.6rem] font-bold uppercase leading-[0.95] text-bone sm:text-6xl lg:text-[4.2rem]" data-id="element-170" data-mp="1ajux6tmeaq80">
              Smetti di improvvisare e ottieni{' '}
              <span className="text-arc-light" data-id="element-171" data-mp="4n4zklpnwqah">cordoni forti e puliti</span>
            </h1>
            <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-mute sm:text-lg lg:mx-0" data-id="element-172" data-mp="3vvslb2rtefik">
              Dimentica tentativi ed errori, impostazioni confuse e ore infinite passate a cercare
              video sulla saldatura.
            </p>
            <p className="mx-auto mt-3 max-w-xl text-[15px] font-medium leading-relaxed text-bone/90 sm:text-lg lg:mx-0" data-id="element-173" data-mp="nfhd84lrndzx">
              Il Sistema Maestro di Saldatura™ ti guida passo dopo passo per configurare la tua
              saldatrice, evitare gli errori più comuni e saldare con maggiore sicurezza fin dalle
              prime prove.
            </p>
          </div>

          <div className="order-first lg:order-none" data-id="element-174" data-mp="1b6mr4e85bw7l">
            <img src={HERO_IMAGE} alt="Sistema Maestro di Saldatura — 6 manuali, bonus e accesso digitale" className="mx-auto w-full max-w-md drop-shadow-2xl lg:max-w-full" width={1080} height={1080} data-id="element-175" data-mp="16d0kb2onymjp" />
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-176" data-mp="2qvkwkrqi2zvb">
          <CtaBlock label="🔥 VOGLIO ORA IL SISTEMA MAESTRO DI SALDATURA" note="" data-id="element-177" data-mp="2vup3tctv6nj0" />
          <div id="cta-sentinel" aria-hidden="true" className="h-px w-full" data-id="element-178" data-mp="2hvfrwpcoyfku" />
          <ul className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1.5" data-id="element-179" data-mp="2hxiq3wnzzf0n">
            {trust.map(item => <li key={item} className="text-[12px] font-semibold text-mute sm:text-sm" data-id="element-180" data-mp="27x9qe8usrbgi">
                <span className="text-arc-light" data-id="element-181" data-mp="27zmg586sqq44">✓</span> {item}
              </li>)}
          </ul>
        </div>

        <p className="mx-auto mt-10 max-w-2xl border-l-2 border-arc pl-4 text-left text-[15px] font-medium italic leading-relaxed text-bone/90 sm:text-center sm:border-l-0 sm:border-t-2 sm:pl-0 sm:pt-4 sm:text-lg" data-id="element-182" data-mp="65deuz8mq1lq">
          Più di un semplice corso… una guida di riferimento da consultare ogni volta che accendi la
          tua saldatrice.
        </p>
      </div>

      <div className="border-y border-ink-500 bg-ink-800" data-id="element-183" data-mp="1qlurdcjih7ff">
        <dl className="mx-auto grid max-w-5xl grid-cols-2 gap-px px-0 sm:grid-cols-4" data-id="element-184" data-mp="25dlq3iv6d1hw">
          {stats.map(stat => <div key={stat.label} className="px-3 py-5 text-center" data-id="element-185" data-mp="20ksmwzfcu17x">
              <dt className="sr-only" data-id="element-186" data-mp="2ecgxgy9yghms">{stat.label}</dt>
              <dd data-id="element-187" data-mp="2abx0bupdte0n">
                <span className="block font-display text-3xl font-bold text-arc-light sm:text-4xl" data-id="element-188" data-mp="2acg5sbxui9xs">
                  {stat.value}
                </span>
                <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.14em] text-mute sm:text-xs" data-id="element-189" data-mp="2oawmmvpf9gtn">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </header>;
}